import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=f1acbb58&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1acbb58')) {
      api.createRecord('f1acbb58', component.options)
    } else {
      api.reload('f1acbb58', component.options)
    }
    module.hot.accept("./BackButton.vue?vue&type=template&id=f1acbb58&", function () {
      api.rerender('f1acbb58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/BackButton.vue"
export default component.exports